import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { GlobalService } from './shared/services/global_variable.service';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { HttpConfigInterceptor } from './shared/interceptors/httpconfig.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthInterceptor } from './shared/interceptors/auth-interceptor';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';


import { NgbDropdownModule , NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { DialogModule } from 'primeng/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function Httploaderfactory(http: HttpClient) {
 return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LanguageTranslationModule,
        AppRoutingModule,
        DialogModule,
        ReactiveFormsModule,
        ToastModule,
        NgbDropdownModule,
        NgbCollapseModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: Httploaderfactory,
                deps:[HttpClient]
            }
        }),
        BackButtonDisableModule.forRoot({
            preserveScrollPosition: true,
        }),
        NgxSpinnerModule
    ],
    declarations: [AppComponent, HeaderComponent, FooterComponent],
    providers: [
        AuthGuard,
        GlobalService,
        MessageService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
         {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
